"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "PanelComponentProps", {
  enumerable: true,
  get: function get() {
    return _types.PanelComponentProps;
  }
});
exports.default = void 0;

var _spacing = _interopRequireDefault(require("@decisiv/design-tokens/lib/spacing"));

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styleModifiers = require("../../utils/styleModifiers");

var _usePropGetter = _interopRequireDefault(require("../../utils/usePropGetter"));

var _Grid = _interopRequireDefault(require("../Grid"));

var _Controls = _interopRequireDefault(require("./Controls"));

var _ItemHeader = _interopRequireDefault(require("./ItemHeader"));

var _propTypes2 = require("./propTypes");

var _schema = _interopRequireDefault(require("./schema"));

var _useAccordion2 = _interopRequireDefault(require("./useAccordion"));

var _types = require("./types");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var ItemPanelContainer = (0, _styledComponents.default)(_Grid.default.Row).withConfig({
  displayName: "Accordion__ItemPanelContainer",
  componentId: "sc-1ysnizc-0"
})(["height:0;display:none;", ""], (0, _styleModifiers.when)('expanded', (0, _styledComponents.css)(["display:block;height:auto;padding:", " ", ";"], (0, _rem.default)(_spacing.default.base), (0, _rem.default)(_spacing.default.base * 3))));

function renderAccordionItem(sharedItemProps) {
  var isItemExpanded = sharedItemProps.isItemExpanded,
      size = sharedItemProps.size,
      titleHeadingLevel = sharedItemProps.titleHeadingLevel,
      toggle = sharedItemProps.toggle;
  return function (props) {
    var alwaysRender = props.alwaysRender,
        disabled = props.disabled,
        id = props.id,
        PanelComponent = props.PanelComponent;
    var expanded = isItemExpanded(props);
    var getPanelProps = (0, _usePropGetter.default)();
    var itemHeaderId = "accordion-item-header-".concat(id);
    var itemPanelContainerId = "accordion-item-panel-".concat(id);
    return _react.default.createElement(_react.default.Fragment, {
      key: String(id)
    }, _react.default.createElement(_ItemHeader.default, _extends({}, props, {
      expanded: expanded,
      itemHeaderId: itemHeaderId,
      itemPanelContainerId: itemPanelContainerId,
      size: size,
      titleHeadingLevel: titleHeadingLevel,
      toggle: toggle
    })), _react.default.createElement(ItemPanelContainer, {
      "aria-labelledby": itemHeaderId,
      expanded: expanded,
      id: itemPanelContainerId,
      role: "region"
    }, (alwaysRender || expanded) && _react.default.createElement(PanelComponent, {
      getPanelProps: getPanelProps({
        disabled: disabled,
        expanded: expanded,
        size: size
      })
    })));
  };
}

function Accordion(props) {
  var items = props.items,
      size = props.size,
      titleHeadingLevel = props.titleHeadingLevel,
      controls = props.controls;

  var _useAccordion = (0, _useAccordion2.default)(props),
      collapseAll = _useAccordion.collapseAll,
      expandAll = _useAccordion.expandAll,
      isItemExpanded = _useAccordion.isItemExpanded,
      toggle = _useAccordion.toggle;

  return _react.default.createElement(_Grid.default.Container, {
    paddingX: 0
  }, _react.default.createElement(_Controls.default, {
    collapseAll: collapseAll,
    expandAll: expandAll,
    controls: controls
  }), items.map(renderAccordionItem({
    isItemExpanded: isItemExpanded,
    size: size,
    titleHeadingLevel: titleHeadingLevel,
    toggle: toggle
  })));
}

Accordion.propTypes = _objectSpread({}, _schema.default.propTypes, {
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    PanelComponent: _propTypes.default.elementType.isRequired,
    alwaysRender: _propTypes.default.bool,
    disabled: _propTypes.default.bool,
    icon: _propTypes.default.elementType,
    id: _propTypes.default.string.isRequired,
    title: _propTypes.default.string.isRequired
  })).isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  defaultExpanded: _propTypes2.itemIdsValidator,
  // eslint-disable-next-line react/no-unused-prop-types
  expanded: _propTypes2.itemIdsValidator,
  controls: _propTypes.default.oneOf(['show', 'hide', 'disabled'])
});
Accordion.defaultProps = {
  defaultExpanded: undefined,
  expanded: undefined,
  controls: 'show'
};
var _default = Accordion;
exports.default = _default;